// Returns the array-form `gtag('config'|'event', ...)` entries
// already in `window.dataLayer`. Used purely as a diagnostic aid so
// the late-consent console message can enumerate what fired before
// Termly. The late-consent verdict itself lives elsewhere — when
// Google tags are managed by GTM, GTM fires them internally without
// pushing any array-form gtag() entries, so this list will be empty
// even though tags did fire.
//
export default function getPriorGtagEntries() {
  const dataLayer = window.dataLayer || []

  return Array.from(dataLayer).filter(isGtagConfigOrEvent)
}

function isGtagConfigOrEvent(entry) {
  if ( !entry || ( typeof entry.length !== 'number' ) ) {
    return false
  }

  const command = entry[0]

  return ( command === 'config' ) || ( command === 'event' )
}
